import React from 'react';
import {
  GlobalOutlined,
  FacebookOutlined,
  LinkedinOutlined,
  TwitterOutlined,
  InstagramOutlined,
  YoutubeOutlined,
} from '@ant-design/icons';

const KIND_LABELS = {
  website: 'Website',
  web: 'Website',
  site: 'Website',
  homepage: 'Website',
  facebook: 'Facebook',
  fb: 'Facebook',
  instagram: 'Instagram',
  ig: 'Instagram',
  linkedin: 'LinkedIn',
  twitter: 'Twitter',
  x: 'Twitter',
  youtube: 'YouTube',
  yt: 'YouTube',
  tiktok: 'TikTok',
};

function inferKindFromUrl(url) {
  if (!url || !String(url).trim()) return 'Website';
  try {
    const normalized = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    const host = new URL(normalized).hostname.toLowerCase();
    if (host.includes('facebook.')) return 'Facebook';
    if (host.includes('linkedin.')) return 'LinkedIn';
    if (host.includes('twitter.') || host === 'x.com' || host.endsWith('.x.com')) return 'Twitter';
    if (host.includes('instagram.')) return 'Instagram';
    if (host.includes('youtube.') || host.includes('youtu.be')) return 'YouTube';
    if (host.includes('tiktok.')) return 'TikTok';
  } catch {
    /* ignore */
  }
  return 'Website';
}

/** Label for dashboard row: Website, Facebook, LinkedIn, … */
export function websiteKindLabel(site) {
  const tag = site?.tag && String(site.tag).trim();
  if (tag) {
    const k = tag.toLowerCase().replace(/\s+/g, '');
    if (KIND_LABELS[k]) return KIND_LABELS[k];
    return tag.charAt(0).toUpperCase() + tag.slice(1).toLowerCase();
  }
  return inferKindFromUrl(site?.url);
}

const iconStyle = { color: 'var(--varexe-gray-500)', marginTop: 3, fontSize: 15 };

/** Icon by tag / URL host (theme colors only on wrapper). */
export function WebsiteKindIcon({ site }) {
  const u = (site?.url && String(site.url).toLowerCase()) || '';
  const tag = (site?.tag && String(site.tag).toLowerCase()) || '';
  const label = websiteKindLabel(site).toLowerCase();

  if (tag.includes('facebook') || label.includes('facebook') || u.includes('facebook.')) {
    return <FacebookOutlined style={iconStyle} aria-hidden />;
  }
  if (tag.includes('linkedin') || label.includes('linkedin') || u.includes('linkedin.')) {
    return <LinkedinOutlined style={iconStyle} aria-hidden />;
  }
  if (tag.includes('twitter') || tag === 'x' || label.includes('twitter') || u.includes('twitter.') || u.includes('x.com')) {
    return <TwitterOutlined style={iconStyle} aria-hidden />;
  }
  if (tag.includes('instagram') || label.includes('instagram') || u.includes('instagram.')) {
    return <InstagramOutlined style={iconStyle} aria-hidden />;
  }
  if (tag.includes('youtube') || label.includes('youtube') || u.includes('youtube.') || u.includes('youtu.be')) {
    return <YoutubeOutlined style={iconStyle} aria-hidden />;
  }
  return <GlobalOutlined style={iconStyle} aria-hidden />;
}
